import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react-intl';
import Button from '../common/button.js';
import DataLayer from '../common/data-layer.js';
import Image from '../common/image.js';
import RichMessage from '../common/rich-message.js';
import style from './card.style.js';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
var _excluded = ["pack", "onAction"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var Card = function Card(_ref) {
  var pack = _ref.pack,
      onAction = _ref.onAction,
      props = _objectWithoutProperties(_ref, _excluded);

  return jsx(DataLayer, {
    selector: "[Card]#".concat(pack.id),
    triggers: ['view'],
    context: {
      pack: pack
    },
    render: function render(ref) {
      return jsxs("div", _objectSpread(_objectSpread({
        ref: ref,
        css: style.card
      }, props), {}, {
        children: [jsxs("div", {
          children: [jsxs("div", {
            css: style.header,
            children: [jsx("div", {
              css: style.headerLabel,
              children: pack.label
            }), pack.packageOption.badge && jsx(Image, {
              css: style.headerBadge,
              mode: "contain",
              image: pack.packageOption.badge.image
            })]
          }), jsx("h2", {
            css: style.name,
            children: pack.name
          }), jsx("div", {
            css: style.speedText,
            children: jsx(RichMessage, {
              id: "InternetPackage.speedText",
              defaultMessage: "- / -",
              xTags: ['box', 'download', 'download-unit', 'upload', 'upload-unit'],
              values: {
                download: pack.download,
                downloadUnit: pack.downloadUnit,
                upload: pack.upload,
                uploadUnit: pack.uploadUnit
              }
            })
          }), jsx("div", {
            css: style.bundle,
            children: (pack.image1 || pack.image2 || pack.image3 || pack.bundleContent) && jsxs(Fragment, {
              children: [jsx("div", {
                css: style.bundleLabel,
                children: pack.bundleText
              }), jsx("div", {
                css: style.bundleWrapper,
                children: jsxs("div", {
                  css: style.bundleList,
                  children: [pack.bundleContent && jsx("div", {
                    css: style.contentWrap,
                    children: jsx("div", {
                      className: "ck-content",
                      dangerouslySetInnerHTML: {
                        __html: pack.bundleContent
                      }
                    })
                  }), jsxs("div", {
                    css: style.imageContent,
                    children: [pack.image1 && jsx(Image, {
                      css: style.bundleImage,
                      mode: "contain",
                      image: pack.image1
                    }), pack.image1 && pack.image2 && jsx("div", {
                      css: style.bundleDivider
                    }), pack.image2 && jsx(Image, {
                      css: style.bundleImage,
                      mode: "contain",
                      image: pack.image2
                    }), pack.image1 && pack.image2 && pack.image3 && jsx("div", {
                      css: style.bundleDivider
                    }), pack.image3 && jsx(Image, {
                      css: style.bundleImage,
                      mode: "contain",
                      image: pack.image3
                    })]
                  })]
                })
              })]
            })
          })]
        }), jsxs("div", {
          children: [jsx("div", {
            css: style.price,
            children: jsx("h3", {
              css: style.priceText,
              children: jsx(RichMessage, {
                id: "InternetPackage.priceText",
                defaultMessage: "- THB/mo",
                xTags: ['price', 'price-unit', 'interval-type'],
                values: {
                  price: pack.priceSpecial
                }
              })
            })
          }), jsx("div", {
            className: "p-2",
            children: jsx("div", {
              css: style.footerWrapper,
              children: pack.serviceBy.buttonOnCard && jsx(DataLayer, {
                selector: "[Card.button#1]#".concat(pack.id),
                triggers: ['click'],
                context: {
                  pack: pack
                },
                render: function render(ref) {
                  return jsx(Button, {
                    ref: ref,
                    css: style.footerButton,
                    variant: 'outlined',
                    onClick: function onClick() {
                      return onAction('show-modal');
                    },
                    children: pack.serviceBy.buttonOnCard
                  });
                }
              })
            })
          })]
        })]
      }));
    }
  });
};

export { Card as default };